<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title
        >企业注册审核
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @resetForm="handleResetForm"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <!--<el-form-item>-->
          <!--<el-select-->
          <!--v-model="slotForms.forms.provinceId"-->
          <!--placeholder="所属省"-->
          <!--@change="provinceChange"-->
          <!--clearable-->
          <!--filterable-->
          <!--&gt;-->
          <!--<el-option-->
          <!--v-for="item in provinceList"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.id"-->
          <!--&gt;</el-option>-->
          <!--</el-select>-->
          <!--</el-form-item>-->

          <!--<el-form-item>-->
          <!--<el-select-->
          <!--v-model="slotForms.forms.cityId"-->
          <!--placeholder="所属市"-->
          <!--@change="cityChange"-->
          <!--clearable-->
          <!--filterable-->
          <!--&gt;-->
          <!--<el-option-->
          <!--v-for="item in cityList"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.id"-->
          <!--&gt;</el-option>-->
          <!--</el-select>-->
          <!--</el-form-item>-->

          <!--<el-form-item>-->
          <!--<el-select-->
          <!--v-model="slotForms.forms.countyName"-->
          <!--placeholder="所属区县"-->
          <!--clearable-->
          <!--filterable-->
          <!--&gt;-->
          <!--<el-option-->
          <!--v-for="item in countyList"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name"-->
          <!--&gt;</el-option>-->
          <!--</el-select>-->
          <!--</el-form-item>-->
          <el-form-item prop="forms.regisArea">
            <e6-city
              ref="e6City"
              :format="$GLOBAL_CONFIG.e6City.format"
              :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
              :label="slotForms.forms.regisArea"
              class="e6-city"
              @selected="citySelect"
            ></e6-city>
            <!-- :fixed-bin="$GLOBAL_CONFIG.e6City.bin" -->
          </el-form-item>
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.corpState">
            <dict-select
              v-model="slotForms.forms.corpState"
              placeholder="审核状态"
              :pkey="'corp_state'"
            ></dict-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格tab -->
    <section class="g-table-tab-section table-tab-section fixed-view">
      <e6-flank-fix>
        <template slot="fixRight">
          <i
            class="flank-fix__item e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
          ></i>
        </template>
      </e6-flank-fix>
    </section>
    <!-- 表格tab end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <!-- <el-table-column align="center" label="附件" width="120">
          <template slot-scope="scope">
            <el-button
            @click="handlePreview(scope)"
              type="text"
              size="small"
            >
              <img width="100%" :src="scope.row.attachment" alt=""></el-button>
            
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <router-link
              v-if="
                operationSuper.审核 &&
                  (scope.row.corpState === 1 || scope.row.corpState === 0)
              "
              :to="{
                path: '/baseComparyReviewEdit',
                query: { pageType: '2', id: scope.row.comparyId }
              }"
              >审核</router-link
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import e6City from "e6city";
// import smallMap from "@/components/smallMap/smallMap";
import { FetchGetArea } from "@/api/public";
import { mapActions } from "vuex";
import listInit from "@/mixins/listInit";
import { mergeFormExtend } from "_private/utils/merge";
import operationManage from "_private/mixins/operationManage";
export default {
  components: { e6City },
  mixins: [listInit, operationManage],
  data() {
    return {
      isSearch: false,
      formExtend: {
        forms: {
          provinceName: $GLOBAL_CONFIG.e6City.provinceName,
          provincId: "",
          cityName: $GLOBAL_CONFIG.e6City.cityName,
          cityId: "",
          countyName: "",
          countyId: "",
          corpState: "",
          comparyName: ""
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      columSetVisible: false,
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      provinceList: [],
      cityList: [],
      countyList: [],
      errMess: "",
      dialogImageUrl: "",
      dialogVisible: false,
      // 请求表格数据
      tableDataUrl: "/base/comparyReview/findByPage"
    };
  },

  created() {
    this.FetchGetArea(0, 1, 1);
    this.setSearchFormIsOpenAct();
    this.initPage(0);
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),

    handlePreview(scop) {
      this.dialogImageUrl = scop.row.attachment;
      this.dialogVisible = true;
    },

    // 根据父级获取地区下拉框
    FetchGetArea(parentId, type, num) {
      FetchGetArea(parentId, type)
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            if (num == 1) {
              this.provinceList = response.result;
            } else if (num == 2) {
              this.cityList = response.result;
            } else if (num == 3) {
              this.countyList = response.result;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "香港") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "台湾省") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
      }
    },
    //省选择事件
    provinceChange() {
      this.cityList = [];
      this.countyList = [];
      this.formExtend.forms.cityName = "";
      this.formExtend.forms.cityId = "";
      this.formExtend.forms.countyName = "";

      this.provinceList.forEach(item => {
        if (this.formExtend.forms.provinceId == item.id) {
          this.formExtend.forms.provinceName = item.name;
          return;
        }
      });
      this.FetchGetArea(this.formExtend.forms.provinceId, 2, 2);
    },
    //市选择事件
    cityChange() {
      this.coutyList = [];
      this.formExtend.forms.countyName = "";
      this.cityList.forEach(item => {
        if (this.formExtend.forms.cityId == item.id) {
          this.formExtend.forms.cityName = item.name;
          return;
        }
      });
      this.FetchGetArea(this.formExtend.forms.cityId, 3, 3);
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        curPage: this.curPage,
        pageSize: this.pageSize
      });
    },
    //重置
    handleResetForm() {
      this.formExtend.forms.cityId = "";
      this.formExtend.forms.provinceId = "";
      this.formExtend.forms.countyName = "";
      this.formExtend.forms.cityName = "";
      this.formExtend.forms.provinceName = "";
      this.$refs.e6City.clearCity();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 0 10px;
}
.table-section {
  height: 200px;
}
.pagination-section {
  padding: 10px 0;
}
.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
